import fifaEvents from './fifa-events.json'

// Default number of days before an event to show it on the map
export const DEFAULT_DISPLAY_DAYS_BEFORE = 7

export const EVENTS = [...fifaEvents]

/**
 * Helper function to determine if an event should be displayed
 * @param {Object} event - Event object with datetime and optional displayDaysBefore
 * @param {Date} now - Current date/time 
 * @returns {boolean} - Whether event should be shown
 */
export const isEventLive = (event, now = new Date()) => {
  const eventDate = new Date(event.datetime)
  const eventDateEnd = new Date(eventDate)
  eventDateEnd.setHours(23, 59, 59, 999) // End of event day

  // Calculate days until event (use floor for negative, ceil for positive to get accurate day count)
  const timeDiff = eventDate - now
  const daysUntil = timeDiff >= 0
    ? Math.ceil(timeDiff / (1000 * 60 * 60 * 24))
    : Math.floor(timeDiff / (1000 * 60 * 60 * 24))

  const displayDaysBefore = event.displayDaysBefore !== undefined
    ? event.displayDaysBefore
    : DEFAULT_DISPLAY_DAYS_BEFORE

  // Show if: within display window (event hasn't happened yet)
  const isInDisplayWindow = daysUntil >= 0 && daysUntil <= displayDaysBefore

  // Show if: currently on event day (from event start until end of day)
  const isEventDay = now >= eventDate && now <= eventDateEnd

  return isInDisplayWindow || isEventDay
}

/**
 * Get all events that are currently live/active
 * @param {Date} now - Current date/time (defaults to new Date())
 * @returns {Array} - Array of live events
 */
export const getLiveEvents = (now = new Date()) => {
  return EVENTS.filter(event => isEventLive(event, now))
}
